import { render, staticRenderFns } from "./trans_dorm.vue?vue&type=template&id=15c83dc2&scoped=true"
import script from "./trans_dorm.vue?vue&type=script&lang=js"
export * from "./trans_dorm.vue?vue&type=script&lang=js"
import style0 from "./trans_dorm.vue?vue&type=style&index=0&id=15c83dc2&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c83dc2",
  null
  
)

export default component.exports